import { render, staticRenderFns } from "./ErrorView.vue?vue&type=template&id=67dc7e5d&scoped=true"
import script from "./ErrorView.vue?vue&type=script&lang=js"
export * from "./ErrorView.vue?vue&type=script&lang=js"
import style0 from "./ErrorView.vue?vue&type=style&index=0&id=67dc7e5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dc7e5d",
  null
  
)

export default component.exports